import { ItineraryImage } from './../itineray.model';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-user-profile-image-form-field',
  templateUrl: './user-profile-image-form-field.component.html',
  styleUrls: ['./user-profile-image-form-field.component.css']
})
export class UserProfileImageFormFieldComponent {

  image: ItineraryImage;

  @Input()
  imageUrl: string;

  @Output()
  imageUrlChange = new EventEmitter<string>();

  @Input()
  userId: string;

  @Input()
  label: string;

  constructor() { }

}
